import React, { useEffect, useState } from 'react';
import { Box } from '@synergy-marine-group/synergy-ui';
import { Menu, MenuItem } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumNavigation from './BreadCrumNavigation';
import backArrow from '../../images/icons/arrow-back.svg';
import poIcon from '../../images/icons/po-icon.svg';
import expenseIcon from '../../images/icons/expense-icon.svg';
import vendorIcon from '../../images/icons/vendor-icon.svg';
import handsIcon from '../../images/icons/hands.svg';
import logsIcon from '../../images/icons/log-icon.svg';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';

const COST_CENTRE_HEADER_NAMES = [
  'cost centres',
  'vessel cost centres',
  'fixed budget vessel company codes',
  'fixed budget vessel account codes'
];

const EXPENSE_MENU_PATHS = {
  '/expense-items': '/expense-items',
  '/vendors': '/vendors'
};

const getActiveExpenseMenuLink = (pathname = '') => {
  if (pathname.startsWith('/expense-items')) {
    return EXPENSE_MENU_PATHS['/expense-items'];
  }
  if (pathname.startsWith('/vendors') || pathname.startsWith('/vendor/')) {
    return EXPENSE_MENU_PATHS['/vendors'];
  }
  return null;
};

const getActiveCostCentreMenuLink = (pathname = '') => {
  if (pathname.startsWith('/cost-centres')) {
    return '/cost-centres';
  }
  if (pathname.startsWith('/fixed-budget-vessel-company-codes')) {
    return '/fixed-budget-vessel-company-codes';
  }
  if (pathname.startsWith('/fixed-budget-vessel-account-codes')) {
    return '/fixed-budget-vessel-account-codes';
  }
  return null;
};

const Header = (props) => {
  const { parentPageLink, headerName } = props;
  const history = useHistory();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(headerName);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [openMenuKey, setOpenMenuKey] = useState(null);
  const policies = returnPolicies();

  const canAccessExpenseItems = policies?.expensePolicies?.canAccess;
  const canAccessVendorMapping = policies?.vendorPolicies?.canAccess;
  const canAccessExpenseMenu = canAccessExpenseItems || canAccessVendorMapping;
  const canAccessCostCentresMenu = policies?.sapPoAdminPolicies?.canAccess;

  const expenseMenuItems = [
    canAccessExpenseItems && {
      name: 'Expense Items',
      link: '/expense-items'
    },
    canAccessVendorMapping && {
      name: 'Vendor to Expense Mapping',
      link: '/vendors'
    }
  ].filter(Boolean);

  const activeExpenseMenuLink = getActiveExpenseMenuLink(location.pathname);
  const activeCostCentreMenuLink = getActiveCostCentreMenuLink(location.pathname);

  const costCentreMenuItems = [
    {
      name: 'Vessel Cost Centres',
      link: '/cost-centres'
    }
    // {
    //    name: 'Fixed Budget Vessel Company Codes',
    //    link: '/fixed-budget-vessel-company-codes'
    //  },
    // {
    //   name: 'Fixed Budget Vessel Account Codes',
    //   link: '/fixed-budget-vessel-account-codes'
    // }
  ];

  const tabs = [];
  if (policies?.logPolicies?.canAccess) {
    tabs.push(
      {
        type: 'link',
        name: 'logs',
        link: '/logs',
        icon: <img src={logsIcon} alt="React Logo" />
      }
    );
  }
  if (canAccessExpenseMenu) {
    tabs.push({
      type: 'menu',
      menuKey: 'expense',
      name: 'Expense Items',
      icon: <img src={expenseIcon} alt="Expense Items" />,
      menuItems: expenseMenuItems,
      isActive: Boolean(activeExpenseMenuLink),
      activeMenuLink: activeExpenseMenuLink
    });
  }
  if (canAccessCostCentresMenu) {
    tabs.push({
      type: 'menu',
      menuKey: 'costCentres',
      name: 'Cost Centres',
      icon: <img src={vendorIcon} alt="Cost Centres" />,
      menuItems: costCentreMenuItems,
      isActive: Boolean(activeCostCentreMenuLink),
      activeMenuLink: activeCostCentreMenuLink
    });
  }
  if (policies?.poPolicies?.canAccess || policies?.vendorDashboardPolicies?.canAccess) {
    tabs.push(
      {
        type: 'link',
        name: 'purchase orders',
        link: '/',
        icon: <img src={poIcon} alt="React Logo" />
      }
    );
  }
  if (policies?.ppePolicies?.canAccess) {
    tabs.push(
      {
        type: 'link',
        name: 'ppe',
        link: '/ppe',
        icon: <img src={handsIcon} alt="React Logo" />
      }
    );
  }

  useEffect(() => {
    const normalizedHeaderName = headerName?.toLowerCase();

    if (normalizedHeaderName === 'synergy kaas') {
      setSelectedTab('purchase orders');
    } else if (
      normalizedHeaderName === 'expense items'
      || normalizedHeaderName === 'vendor to expense mapping'
    ) {
      setSelectedTab('Expense Items');
    } else if (COST_CENTRE_HEADER_NAMES.includes(normalizedHeaderName)) {
      setSelectedTab('Cost Centres');
    } else {
      setSelectedTab(headerName);
    }
  }, [headerName]);

  const handleMenuOpen = (event, menuKey) => {
    setMenuAnchorEl(event.currentTarget);
    setOpenMenuKey(menuKey);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setOpenMenuKey(null);
  };

  const handleMenuNavigate = (link) => {
    handleMenuClose();
    history.push(link);
  };

  return (
    <Box className="pl-6 mb-2 synergy-app-header pt-1">
      <div className="flex flow-row items-center">
        {parentPageLink && (
          <button type="button" onClick={() => history.push(parentPageLink)}>
            <img src={backArrow} alt="React Logo" />
          </button>
        )}
        <div className="flex-col mb-2 text-xs items-center">
          <h2 className="text-xl font-bold mb-1.2 font-muli ">{headerName}</h2>
          <BreadCrumNavigation {...props} />
        </div>
        <div className="ml-auto sub-link-btn-wrap font-montserrat font-semibold pr-8">
          {tabs.map((tab) => (
            tab.type === 'menu' ? (
              <React.Fragment key={tab.menuKey}>
                <button
                  className={`sub-link-btn uppercase ${tab.isActive ? 'active' : ''}`}
                  onClick={(event) => handleMenuOpen(event, tab.menuKey)}
                  type="button"
                >
                  {tab.name}
                  {tab.icon}
                </button>
                <Menu
                  className="sac-menu"
                  anchorEl={menuAnchorEl}
                  keepMounted
                  open={openMenuKey === tab.menuKey && Boolean(menuAnchorEl)}
                  onClose={handleMenuClose}
                  PaperProps={{ className: 'sac-menu-paper' }}
                  MenuListProps={{ className: 'sac-menu-list' }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                  }}
                  getContentAnchorEl={null}
                  style={{ marginTop: '8px' }}
                >
                  {tab.menuItems.map((item) => (
                    <MenuItem
                      key={item.link}
                      className="sac-menu-item uppercase font-montserrat font-semibold text-xs"
                      selected={tab.activeMenuLink === item.link}
                      onClick={() => handleMenuNavigate(item.link)}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Menu>
              </React.Fragment>
            ) : (
              <button
                key={tab.name}
                className={`sub-link-btn uppercase ${tab?.name?.toLowerCase() === selectedTab?.toLowerCase() ? 'active' : ''}`}
                onClick={() => history.push(tab?.link)}
                type="button"
              >
                {tab?.name}
                {tab?.icon}
              </button>
            )
          ))}
        </div>
      </div>
    </Box>
  );
};

export default Header;
